import { render, staticRenderFns } from "./AMQPdRes.vue?vue&type=template&id=2b07948a&scoped=true&"
import script from "./AMQPdRes.vue?vue&type=script&lang=js&"
export * from "./AMQPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07948a",
  null
  
)

export default component.exports